import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "./LangContext";
import { ContactProvider, useContact } from "./ContactContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Mission } from "./components/Mission";
import { Universes } from "./components/Universes";
import { FollowMe } from "./components/FollowMe";
import { BoxShowcase } from "./components/BoxShowcase";
import { Founders } from "./components/Founders";
import { Manifesto } from "./components/Manifesto";
import { Upcoming } from "./components/Upcoming";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { ContactDialog } from "./components/ContactDialog";

const Landing = () => {
  const { open, setOpen } = useContact();
  return (
    <div className="App baj-page-bg min-h-screen relative" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Mission />
        <Universes />
        <FollowMe />
        <BoxShowcase />
        <Founders />
        <Manifesto />
        <Upcoming />
        <FinalCTA />
      </main>
      <Footer />
      <ContactDialog open={open} onOpenChange={setOpen} />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <LangProvider>
      <ContactProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </ContactProvider>
    </LangProvider>
  );
}

export default App;
